import select2 from 'select2';
import './../../../node_modules/select2/dist/css/select2.css';
import './../../../node_modules/select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css';

/* global naja, $, intervalFunction */
class Select2Extension {
    init()
    {
        this.initSelect2();
    }
    initSelect2()
    {
        $('.select2-init').each(
            function () {
                if (!$(this).hasClass('select2-hidden-accessible')) {
                    const options = {
                        theme: 'bootstrap-5',
                    };

                    if ($(this).closest('.modal').length){
                        options.dropdownParent = $(this).closest('.modal');
                    }

                    if ($(this).hasClass('select2-serial-numbers')) {
                        options.language = {
                            noResults: function () {
                                return "<p class=\"alert alert-danger\">Sériové číslo nenalezeno</p>";
                            }
                        };
                        options.escapeMarkup = function (markup) {
                            return markup;
                        };
                    }

                    $(this).select2(
                        options
                    );

                    $(this).on('select2:open', function () {
                        const searchField = $('.select2-container--open .select2-search__field');
                        if (searchField.length) {
                            searchField[0].focus();
                        }
                    });
                }
            }
        );

        $('.select2-tags-init').each(
            function () {
                if (!$(this).hasClass('select2-hidden-accessible')) {
                    const options = {
                        theme: 'bootstrap-5',
                        tags: true,
                    };

                    if ($(this).closest('.modal').length){
                        options.dropdownParent = $(this).closest('.modal');
                    }

                    $(this).select2(
                        options
                    );


                    $(this).on('select2:open', function () {
                        const searchField = $('.select2-container--open .select2-search__field');
                        if (searchField.length) {
                            searchField[0].focus();
                        }
                    });

                    // FIX BUG: Workaround for select2 not updating value when using tags
                    var s = $(this);
                    const selectedValues = $(this).find(':selected').map(function() {
                        return $(this).val();
                    }).get();

                    setTimeout(function () {
                        s.val(selectedValues).trigger('change');
                    }, 300);
                }
            }
        );
    }
    initialize(naja)
    {
        naja.addEventListener('complete', this.initSelect2.bind(this));
    }
}

export default Select2Extension;
